const invoicePDFLink = document.querySelector('#invoice-pdf-link');
const hideStudyLink = document.querySelector('#hide-color-study-link');

if (invoicePDFLink) {
  invoicePDFLink.addEventListener('click', (e) => {
    e.preventDefault();

    const base64Data = e.target.href;

    const byteCharacters = atob(base64Data.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');
  });
}

if (hideStudyLink) {
  hideStudyLink.addEventListener('click', (e) => {
    e.preventDefault();
    const { action, hash } = hideStudyLink.dataset;

    axiosGetRedirectUrl(action, hash);
  });

  const axiosGetRedirectUrl = async (action, hash) => {
    const axiosData = {
      action,
      hash,
      localData,
      nonce: await getNonceForAction(action),
    };

    try {
      const { data } = await axios.post(localData.siteURL, axiosData);

      if (data?.success === true && data?.data?.redirect_url) {
        const safeUrl = encodeURI(data.data.redirect_url);
        window.open(safeUrl, '_blank');
      } else if (!data?.success) {
        console.error('Failed to hide study:', data?.message || 'Unknown error');
      }
    } catch (err) {
      console.error('AJAX error:', err);
    }
  };
}
